"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingFailedWidget = exports.loadingFailedWidgetTestId = void 0;
const tslib_1 = require("tslib");
const catalog_messages_1 = require("@tableau/catalog-messages");
const data_catalog_shared_1 = require("@tableau/data-catalog-shared");
const widgets_1 = require("@tableau/widgets");
const react_1 = tslib_1.__importDefault(require("react"));
const ViewerPaneStyles_1 = require("./ViewerPaneStyles");
exports.loadingFailedWidgetTestId = 'loading-failed';
class LoadingFailedWidget extends react_1.default.Component {
    headlineForErrorCode(errorCode) {
        const genericError = catalog_messages_1.Messages.Error();
        if (errorCode === null) {
            return genericError;
        }
        switch (errorCode) {
            case 'BACKFILL_RUNNING':
                return catalog_messages_1.Messages.DataDetailsBackfillRunningHeadline();
            case 'RATE_EXCEEDED':
                return catalog_messages_1.Messages.DataDetailsRateExceededHeadline();
            case 'TIME_LIMIT_EXCEEDED':
                return catalog_messages_1.Messages.DataDetailsTimeLimitExceededHeadline();
            case 'NODE_LIMIT_EXCEEDED':
                return catalog_messages_1.Messages.DataDetailsNodeLimitExceededHeadline();
            case 'INGESTION_FAILED':
            case 'INTERNAL_SERVER_ERROR':
            case 'FEATURE_DISABLED':
            default:
                return genericError;
        }
    }
    detailsForErrorCode(errorCode) {
        const genericError = catalog_messages_1.Messages.DataDetailsGenericErrorDetails();
        if (errorCode === null) {
            return genericError;
        }
        switch (errorCode) {
            case 'INGESTION_FAILED':
                return catalog_messages_1.Messages.DataDetailsIngestionFailedDetails();
            case 'RATE_EXCEEDED':
                return catalog_messages_1.Messages.DataDetailsRateExceededDetails();
            case 'TIME_LIMIT_EXCEEDED':
                return catalog_messages_1.Messages.DataDetailsTimeLimitExceededDetails();
            case 'NODE_LIMIT_EXCEEDED':
                return catalog_messages_1.Messages.DataDetailsNodeLimitExceededDetails();
            case 'INTERNAL_SERVER_ERROR':
                return catalog_messages_1.Messages.DataDetailsInternalServerErrorDetails();
            case 'FEATURE_DISABLED':
                return catalog_messages_1.Messages.ErrorFeatureDisabled();
            default:
                return genericError;
        }
    }
    render() {
        return (react_1.default.createElement("div", { className: ViewerPaneStyles_1.lineagePanelBodyWithError, "data-tb-test-id": exports.loadingFailedWidgetTestId },
            react_1.default.createElement(data_catalog_shared_1.CenteredMessage, { message: this.headlineForErrorCode(this.props.errorCode) }),
            react_1.default.createElement(ViewerPaneStyles_1.LoadingErrorMessage, null, this.detailsForErrorCode(this.props.errorCode)),
            this.props.onRetryRequested
                ? (react_1.default.createElement(widgets_1.ButtonWidget, { buttonType: widgets_1.ButtonType.Outline, testId: 'retry-load-button', handleClick: this.props.onRetryRequested }, catalog_messages_1.Messages.LoadingFailedButtonText()))
                : null));
    }
}
exports.LoadingFailedWidget = LoadingFailedWidget;
//# sourceMappingURL=LoadingFailedWidget.js.map